//vulnerability disclosure page component 
//*******************************************************************
//*******************************************************************
//IMPORTS:
//EXTERNAL & PACKAGE
import $ from 'jquery'
import Popper from 'popper.js'
import React from 'react';
import {graphql, Link} from 'gatsby';
import Iframe from 'react-iframe';
import GoogleFontLoader from 'react-google-font-loader';
//*******************************************************************
//COMPONENT DEPENDENCIES
//static
import Heading from '../../components/heading';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
//props
import PageHeader from '../../components/PageHeader';
import FullWidthImage from '../../components/FullWidthImage';
import TextBlock from '../../components/textblock';
import ContentBlock from '../../components/ContentBlock';
import ContentSection from '../../components/ContentSection';
import Header from '../../components/Header';
import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************
//*******************************************************************
//*******************************************************************        
const vulnerabilityDisclosurePage = ({data}) => {
    
    return (
        <div>
            
            <Helmet>
                   <title>NJCCIC Vulnerability Disclosures</title>
                   <meta name="description" content="Disclose a vulnerability to the NJCCIC"/>
            </Helmet>
            <Heading/>
            
            <Navbar/>
        
            <div class="container-fluid">
                
                <div class="containerWidth">
        
                    <Iframe src="https://nj-ohsp--uat.sandbox.my.salesforce-sites.com/vulnerabilityForm"
                            width="100%"
                            height="1325px"
                            id="myId"
                            className="iframeBlock"
                            display="initial"
                            position="relative"/>
                    
                </div>
                
            </div>

            <Footer/>
               
        </div>
    )
}
//*******************************************************************
//*******************************************************************

export default vulnerabilityDisclosurePage
